import styled from 'styled-components'
import AppButton from 'Components/AppButton'

export const _WithLoginBlurBox = styled.div`
  position: relative;
`

export const _BlurContainer = styled.div`
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  filter: blur(8px);
  -webkit-filter: blur(8px);

`

export const _AppBtn = styled(AppButton)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  border-radius: 10px;

  `
